import { render } from "./gift-icon.vue.js?vue&type=template&id=123505c2!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./gift-icon.vue?vue&type=template&id=123505c2"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__